import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { CaretDown, FilePdf, MagicWand, UserSwitch } from "@phosphor-icons/react";
import BulkActions, { RunAIButton, RunDisclosureButton } from "./BulkActions";
import { useRightSidebar } from "../../../../../context/RightSidebarContext";
import { useSelector } from "react-redux";
import useAirUserRoles from "../../../../../utils/AuthUtils";
import { colors } from "../../../../../theme/foundations/colors";
import React from "react";

/**
 * BulkActionsList
 * @param filteredQuestionList
 * @param filterBy
 * @param actionList, actions to be enabled, if not provided, all actions will be enabled. (e.g. ["RunAI", "RunDisclosure", "Manage"])
 * @returns {Element}
 * @constructor
 */
const BulkActionsList = ({ filteredQuestionList, filterBy, actionList }) => {
  const { setRightSidebar, doOpen, doClose, activationId, isOpen } = useRightSidebar();

  const { isController } = useAirUserRoles();

  const roundSelector = useSelector((state) => state.issbRound);
  const questionnaireId = roundSelector.selectedRound?.id;

  const bulkActionOpen = activationId === "BulkActions" && isOpen;
  const toggleBulkActions = () => {
    const newBulkAction = !bulkActionOpen;
    if (newBulkAction) {
      setRightSidebar(<BulkActions filteredQuestionList={filteredQuestionList} filteredKeywords={filterBy} />);
      doOpen("BulkActions");
    } else {
      if (activationId === "BulkActions") {
        doClose();
      }
    }
  };

  return (
    <Menu>
      <MenuButton as={Button} variant="secondary" rightIcon={<CaretDown color="#63AD03" size={18} />}>
        Actions
      </MenuButton>
      <MenuList fontSize="body.s">
        {/* only show run ai button if actionList is not provided or RunAI is included in action list */}
        {(!actionList || actionList.includes("RunAI")) && (
          <RunAIButton questionnaireId={questionnaireId} questions={filteredQuestionList} />
        )}
        {(!actionList || actionList.includes("RunDisclosure")) && (
          <RunDisclosureButton questionnaireId={questionnaireId} filters={filterBy} />
        )}
        {(!actionList || actionList.includes("Manage")) && (
          <MenuItem
            icon={<UserSwitch size={16} />}
            onClick={() => {
              toggleBulkActions();
            }}
            isDisabled={!isController()}
            title={
              !isController()
                ? "You must be a controller to manage questions"
                : "Apply bulk actions to selected questions"
            }
          >
            Manage
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};

export default BulkActionsList;
